import React from 'react';
import './reviews.css'
import stars from './../../../assets/stars.svg'
import BodyTxt from './body';

const Review = (props) => {
    return ( <>
    <div className="revCard">
        <h3>
            {props.name}
        </h3>
        <img src={stars} alt="" />
        <BodyTxt text={props.text} />
    </div>
    </> );
}
 
export default Review;